import PropTypes from 'prop-types';
import React from 'react';
const TableSelect = ({ checked, id, row, selectType, onClick }) => {
    const input = (React.createElement("div", { style: { textAlign: 'left' } },
        React.createElement("input", { checked: checked || false, style: { marginTop: 0 }, type: selectType, onClick: e => {
                const { shiftKey } = e;
                e.stopPropagation();
                onClick(id, shiftKey, row);
            }, onChange: () => { } })));
    return input;
};
TableSelect.propTypes = {
    checked: PropTypes.bool,
    id: PropTypes.string,
    row: PropTypes.objectOf(PropTypes.any),
    selectType: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};
export default TableSelect;
